import React, { useState } from "react";

import VisibilitySensor from "react-visibility-sensor";
import { useTranslation } from "react-i18next";

import img2 from '../../../assets/img/about/aboutOne/img2.webp';

function AboutOneB(){

    const { t } = useTranslation();

    const [isVisible, setIsVisible] = useState(false);

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    return(
        <VisibilitySensor onChange={onChange} partialVisibility minTopValue={460}>
        <div className={`aboutOneB ${isVisible ? 'visible' : ''}`}>
            <div className="aboutOneC2">
                <div className="text">
                    <h1 className={`${isVisible ? 'visible' : ''}`}>{t("about_oneb_title")} <span>{t("about_oneb_title_span")}</span></h1>
                    <p className={`${isVisible ? 'visible' : ''}`}>
                        {t("about_oneb_text")}
                    </p>
                </div>
                <img className={`${isVisible ? 'visible' : ''}`} src={img2} alt="" width={'500px'}/>
            </div>
        </div>
        </VisibilitySensor>
    )
}

export default AboutOneB;